import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M 20.071,7.72293 12,2.96103 3.92901,7.72294 9.2653,10.8619 C 9.41898,10.9523 9.59403,11 9.77232,11 h 4.45538 c 0.1783,0 0.3534,-0.0477 0.507,-0.1381 z M 1.00023,7.72725 C 0.990952,7.3758 1.16763,7.03 1.49189,6.83869 L 11.4919,0.938688 c 0.3135,-0.184974 0.7028,-0.184974 1.0163,0 l 10,5.900002 c 0.3245,0.19149 0.5013,0.53776 0.4916,0.88955 L 23,7.74842 V 20 c 0,0.5523 -0.4477,1 -1,1 H 2.00002 C 1.44773,21 1.00001,20.5523 1.00001,20 V 7.74842 Z M 21,17.4635 V 9.49683 L 16.4603,12.1672 Z M 14.5273,12.985 C 14.428,12.995 14.328,13 14.2277,13 H 9.77232 C 9.672,13 9.57202,12.995 9.47274,12.985 L 4.31703,19 H 19.683 Z M 3.00001,9.49683 v 7.96667 l 4.53967,-5.2963 z"
  }));
});
var DescriptiveEnvelopeOpen = AbstractIcon.withComponent(Icon);
DescriptiveEnvelopeOpen.displayName = 'DescriptiveEnvelopeOpen';
export default DescriptiveEnvelopeOpen;